import { createFileRoute } from "@tanstack/react-router";
import { BlogIndex, FAQ_SECTIONS } from "./blog";
import { listBlogPosts } from "@/lib/site.functions";

// Plain-text version of a visible FAQ answer: paragraphs (and the callout,
// when present) joined exactly as displayed, with ** emphasis markers removed.
function faqAnswerText(item: { a: string[]; callout?: string }): string {
  const parts = item.callout ? [...item.a, item.callout] : item.a;
  return parts.map((p) => p.replace(/\*\*([^*]+)\*\*/g, "$1")).join("\n\n");
}

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "@id": "https://saased.co/blog#faq",
  mainEntity: FAQ_SECTIONS.flatMap((section) =>
    section.items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: faqAnswerText(item) },
    })),
  ),
};

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Salesforce Procurement Insights, Playbooks & Case Studies" },
      { name: "description", content: "Expert analysis, hidden commercial risks, and tactical playbooks for IT leaders and CFOs managing Salesforce renewals." },
      { property: "og:title", content: "Salesforce Procurement Insights, Playbooks & Case Studies" },
      { property: "og:description", content: "Expert analysis, hidden commercial risks, and tactical playbooks for IT leaders and CFOs managing Salesforce renewals." },
      { property: "og:url", content: "https://saased.co/blog" },
    ],
    links: [{ rel: "canonical", href: "https://saased.co/blog" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(faqJsonLd),
      },
    ],
  }),
  loader: () =>
    listBlogPosts(),
  component: BlogIndex,
});
